import { render } from "./taskAndDetails.vue?vue&type=template&id=92a18b7e"
import script from "./taskAndDetails.vue?vue&type=script&lang=js"
export * from "./taskAndDetails.vue?vue&type=script&lang=js"

import "./taskAndDetails.vue?vue&type=style&index=0&id=92a18b7e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__